
const data = [
  {
    id: 1,
    name: "Fire Day",
    name_ar: "اليوم الناري",
    date: "2020-01-01",
    short_story:
      "It was peaceful at Nambala Avenue in Cooktown when Dan Inka was having his night walk. It had been a long and exhausting day in the office, sorting out a mountain of paperwork, so he was quite relieved to get out of his sweaty suit.",
     short_story_ar:"كان الوضع هادئًا في شارع نامبالا في كوكتون عندما كان دان اينكا يمشي ليلًا. لقد كان يومًا طويلًا ومرهقًا في المكتب ، حيث كان يفرز عددًا كبيرًا من الأوراق ، لذلك كان مرتاحًا تمامًا للخروج من بدلته المليئة بالعرق. ",
    
    iamge: "./images/wal1.jpg",
    type: "action",
    mainpage: true,
    screen1: "./images/fire1.jpg",
    screen2: "./images/fire2.jpg",
    screen3: "./images/fire3.jpg",
    screen4: "./images/fire4.jpg",
    screen5: "./images/fire5.jpg",
    screen6: "./images/fire6.jpg",
    screen7: "./images/fire7.jpg",
    cpu: "Intel Core i5-8265U (2.6 GHz)",
    ram: "8 GB",
    gpu: "Intel UHD Graphics 620",
    youtube: "https://www.youtube.com/watch?v=4H1UEHX_7X8",
    rate: "4.5",
    date:'2020-01-01'
  },
  {
    id: 2,
    name: "God Of War",
    date: "2020-05-06",
    short_story:
      "God of War is an action-adventure, hack and slash, mythology-based video game series, originally created by David Jaffe at Sony's Santa Monica Studio. There are 1,245 articles since its inception in September 2007. The wiki format allows anyone to create or edit any article.",
    iamge: "./images/godofwar.jpg",
    type: "action",
    mainpage: true,
    screen1: "./images/god1.jpg",
    screen2: "./images/god2.jpg",
    screen3: "./images/god3.jpg",
    screen4: "./images/god4.jpg",
    screen5: "./images/god5.jpg",
    screen6: "./images/god6.jpg",
    screen7: "./images/god7.jpg",
    cpu: "Intel Core i5-7265U (2.6 GHz)",
    ram: "6 GB",
    gpu: "Intel Gtx 1070",
    youtube: "https://www.youtube.com/watch?v=K0u_kAWLJOA",
    rate: "3.5",
    date:'2021-05-06'
  },
  {
    id: 3,
    name: "codevien",
    date: "2022-05-06",
    short_story:
      "Code Vein is an action role-playing video game developed by Bandai Namco Studios and the creators of the God Eater series, Shift, and published by Bandai Namco Entertainment. It was released in September 27th, 2019 and was launched on the PS4, Xbox One, and PC (via Steam) platforms.",
    iamge: "./images/codev.jpg",
    type: "action",
    mainpage: true,

    screen1: "./images/c3.png",
    screen2: "./images/c1.jpg",
    screen3: "./images/c4.jpg",
    screen4: "./images/c6.jpg",
    screen5: "./images/c5.jpg",
    screen6: "./images/c7.jpg",
    screen7: "./images/c22.jpg",
    cpu: "Intel Core i5-5265U (2.6 GHz)",
    ram: "4 GB",
    gpu: "Intel Gtx 1050",
    youtube: "https://www.youtube.com/watch?v=tXvKDyuObbQ",

    rate: "5",
    date:'2022-05-06'
  },
  {
    id: 4,
    name: "need for speed",
    date: "2020-11-06",
    short_story: "the fourth part of the series",
    iamge: "./images/nfs.jpg",
    type: "action",
    mainpage: false,

    screen1: "./images/need1.jpg",
    screen2: "./images/need2.jpg",
    screen3: "./images/need3.jpg",
    screen4: "./images/need4.jpg",
    screen5: "./images/need5.jpg",
    screen6: "./images/need6.jpg",
    screen7: "./images/need7.jpg",
    cpu: "Intel Core i5-7265U (2.6 GHz)",
    ram: "12 GB",
    gpu: "Intel Gtx 1070",
    youtube: "https://www.youtube.com/watch?v=8jiTNodDe-Y",

    rate: "4",
    date:'2012-05-16'
  },
  
  // {
  //   id: 6,
  //   name: "god of war 5",
  //   date: "2020-05-06",
  //   short_story: "story of little god have super power to kill people",
  //   iamge: "./images/godofwar5.jpg",
  //   type: "action",
  //   mainpage: true,
  // },
  // {
  //   id: 7,
  //   name: "god of war 6",
  //   date: "2020-05-06",
  //   short_story: "story of little god have super power to kill people",
  //   iamge: "../images/godofwar6.jpg",
  //   type: "action",
  //   mainpage: true,
  // },
  // {
  //   id: 8,
  //   name: "god of war 7",
  //   date: "2020-05-06",
  //   short_story: "story of little god have super power to kill people",
  //   iamge: "../images/godofwar7.jpg",
  //   type: "action",
  //   mainpage: true,
  // },
];

export default data;